import type { NotificationsResponse } from "@/features/notifications/types/notifications.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const notificationsService = {
  getUnreadCounts: async (): Promise<NotificationsResponse> => {
    const response = await fetcher.get<NotificationsResponse>("/notifications");
    return response.data;
  },
};
